import config from "config/config";

export const STEPS = [
  "terms_and_conditions_step",
  "submission_disclosure_step",
  "move_in_date",
  "personal_details",
  "dependents",
  "emergency_contacts",
  "pets",
  "vehicles",
  "military_first_responder_teacher",
  "lead_source",
  "additional_questions",
  "address",
  "ssn",
  "identity_documents",
  "identity_address",
  "income_verification",
  "income_documents",
  "checkout"
];

export const StepNames = {
  move_in_date: "Move in date",
  personal_details: "Personal details",
  dependents: "Dependents",
  emergency_contacts: "Emergency contacts",
  pets: "Pets",
  vehicles: "Vehicles",
  military_first_responder_teacher: "Military, First Responder, Teacher",
  lead_source: "Lead source",
  address: "Housing history",
  income_verification: "Income verification",
  submission_disclosure_step: "Submission disclosure",
  checkout: "Checkout",
  additional_questions: "Additional questions",
  identity_documents: "Identity documents",
  identity_address: "Identity address",
  terms_and_conditions_step: "Terms and Conditions",
  income_documents: "Income documents",
  ssn: "Identity information"
};

export const AX_ORIGIN = config.axOrigin;
